import { InstagramScoringEngine } from './scoringEngine';
import { InstagramAuditInput, InstagramAuditResult } from '../../../types/socialMediaAudit';

// This service acts as the orchestrator for Instagram Audits
export class InstagramAuditService {
  private scoringEngine: InstagramScoringEngine;

  constructor() {
    this.scoringEngine = new InstagramScoringEngine();
  }

  // Performs a deterministic audit based on provided profile and insights data.
  // The system relies on proprietary algorithms applied to this data without requiring external APIs.
  public async performAudit(input: InstagramAuditInput): Promise<InstagramAuditResult> {
    
    // Step 1: Validate input
    if (!input.profileData || !input.profileData.username) {
      throw new Error("Invalid profile data provided.");
    }

    // Step 2: Run through deterministic scoring engine
    const auditResult = this.scoringEngine.generateAudit(input);

    return auditResult;
  }
}

export const instagramAuditService = new InstagramAuditService();
